import { useParams } from 'react-router-dom';
import { ProjectsView } from './ProjectsView';
import { WorkspaceView } from './WorkspaceView';

export function KspPage() {
  const { projectId } = useParams();
  return projectId ? <WorkspaceView key={projectId} projectId={projectId} /> : <ProjectsView />;
}
